// entry point for webpack, can import js here, also creates css files

import Swiper, { Navigation, Pagination, Autoplay, EffectFlip, EffectFade } from 'swiper';
// Swiper css and module styles
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-flip';
import 'swiper/css/effect-fade';

// Swiper bundle with all modules installed
// import Swiper from 'swiper/bundle';

// Styles bundle
// import 'swiper/css/bundle';

jQuery(document).ready(function($) {

  // init Swiper
  const swiper = new Swiper('.swiper', {
    modules: [ Navigation, Pagination, Autoplay, EffectFlip, EffectFade ],
    direction: 'horizontal',
    loop: true,
    effect: 'fade',
    autoplay: {
      delay: 2000,
    },
    speed: 300,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

} );


import "./scss/_slider.scss";
